import { AnalyticsEventData } from '@client/analytics/types/types';
import { createAction } from '@reduxjs/toolkit';

export const analyzeEvent = createAction<AnalyticsEventData>('analyzeEvent');
export const analyzeView = createAction<AnalyticsEventData>('analyzeView');
export const analyzeEmmitEventToTealium = createAction<AnalyticsEventData>('analyzeEmmitEventToTealium');
export const analyzeEmmitViewToTealium = createAction<AnalyticsEventData>('analyzeEmmitViewToTealium');
